import {Repository} from '@/repositories/Base/Repository'

class ResultRepository extends Repository {
    endpoint = 'mapping/exams/observation/table'
    endpointCopy = 'mapping/exams/observation/copy'
    postCopy(params) {
        return this.$axios.post(`${this.endpointCopy}`, params)
    }

}

export default new ResultRepository()
